export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15')
];

export const server_loads = [0];

export const dictionary = {
		"/": [3],
		"/[lang]": [4,[2]],
		"/[lang]/about": [5,[2]],
		"/[lang]/how-to-download-instagram-photos": [6,[2]],
		"/[lang]/how-to-download-instagram-videos": [7,[2]],
		"/[lang]/instagram-highlights-downloader": [8,[2]],
		"/[lang]/instagram-igtv-downloader": [9,[2]],
		"/[lang]/instagram-photo-downloader": [10,[2]],
		"/[lang]/instagram-post-downloader": [11,[2]],
		"/[lang]/instagram-reels-downloader": [12,[2]],
		"/[lang]/instagram-story-downloader": [13,[2]],
		"/[lang]/instagram-video-downloader": [14,[2]],
		"/[lang]/privacyPolicy": [15,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';